module.exports = __webpack_public_path__ + "img/contact-info-blue.955f6447.svg";